<template>
  <div class="login">
    <div class="card" style="height: 240px;" v-if="!loading">
        <h2>Login</h2>
        <input type="email" v-model="email" name="email" placeholder="E-mail">
        <input type="password" v-model="password" name="password" placeholder="Password" @keydown.enter="login">
        <div class="bottom">
            <!-- <button @click="$router.push('/register')" class="empty">Register</button> -->
            <button @click="login">Login</button>
        </div>
    </div>
    <div class="card loader" v-else>
        <loader></loader>
    </div>
  </div>
</template>

<script>
import config from '../config';
import Loader from './Loader.vue';

export default {
    name: 'Login',
    
    data () {
        return {
            email: '',
            password: '',
            loading: false
        }
    },
    components: {
        Loader
    },
    methods: {
        login() {
            this.loading = true;
            const email = this.email;
            const password = this.password;

            fetch(config.api + '/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    password: password
                })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.status);
                }
                return response.json();
            })
            .then(data => {
                localStorage.setItem('token', data.token);
                this.$router.push('/models');
            })
            .catch(error => {
                if (error.message === '401')
                    this.notificationController.addNotification({ type: 'error', title: 'Login failed', message: 'Inccorrect login information.', duration: 3000 });
                else if (error.message === '402')
                    this.notificationController.addNotification({ type: 'info', title: 'Pending validation', message: `Your account is not active yet, please check your email for an activation link`, duration: 5000 });
                else
                    this.notificationController.addNotification({ type: 'error', title: 'Login failed', message: `Something went wrong while logging in, please try again.`, duration: 3000 });
            })
            .finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>

<style scoped>

.login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
}

h2 {
    text-align: center;
}

.card {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

input {
    width: 90%;
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border-radius: 8px;
    outline: none;
}

button {
    align-self: center;
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border-radius: 8px;

    font-size: 16px;
    cursor: pointer;
}

.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 240px;
}

.bottom {
    display: flex;
    justify-content: space-between;
}

</style>


// WEBPACK FOOTER //
// src/components/Login.vue